export type GameChatRouteRequest = { focusMessageId?: string }

export function claimGameChatRouteRequest(
  value: string | string[] | undefined,
  previouslyConsumed: string | null,
): { consumedValue: string | null; request?: GameChatRouteRequest } {
  const normalized = Array.isArray(value) ? value[0] : value
  if (typeof normalized !== 'string' || normalized.length === 0) {
    return { consumedValue: null }
  }
  if (normalized === previouslyConsumed) {
    return { consumedValue: previouslyConsumed }
  }
  return {
    consumedValue: normalized,
    request: { focusMessageId: normalized === '1' ? undefined : normalized },
  }
}
